import { EeseCoverageDto } from "src/app/models/dto/eeseCoverageDto";
import { EeseCoverageInput } from "../models/input/graphql-eese-coverage-input";

export function convertEeseCoverageDtoToGraphqlInput(input: EeseCoverageDto): EeseCoverageInput {
  if (!input) return undefined;

  return {
    Uid: input.uid ?? '',
    ItemNo: input.itemNo,
    Name: input.name,
    Version: input.version,
    ModifiedBy: input.modifiedBy,
    ModificationTime: null,
    Comment: input.comment,
    LockedBy: input.lockedBy,
    LockedTime: null,
    CreatedBy: input.createdBy,
    CreationTime: null,
    ApprovalStatus: input.approvalStatus,
    ApprovedForTestLevel: input.approvedForTestLevel,
    Tags: input.tags ?? [],
    Requirements: input.requirements?.map(req => ({
      Id: req.id,
      Name: req.name,
      Revision: req.revision
    })) ?? [],
  }
}
